import i18 from 'i18next';

import { PAGES } from '../pages';

export const corporateAccountMenu = [
  {
    title: i18.t('createAccount'),
    checked: true,
  },
  {
    title: i18.t('secureAccount'),
    path: PAGES.BUSINESS_ACCOUNT.SECURE_ACCOUNT,
    nextPath: PAGES.SECURE_BUSINESS_TYPE,
    previousPath: PAGES.BASE,
    items: [
      {
        title: i18.t('secureBusiness'),
        path: PAGES.SECURE_BUSINESS_TYPE,
        nextPath: PAGES.SECURE_BUSINESS_ORIGIN_NAME,
        previousPath: PAGES.BUSINESS_ACCOUNT.SECURE_ACCOUNT,
        items: [
          {
            path: PAGES.SECURE_BUSINESS_ORIGIN_NAME,
            nextPath: PAGES.SECURE_BUSINESS_ORIGIN_EIN,
            previousPath: PAGES.SECURE_BUSINESS_TYPE,
          },
          {
            path: PAGES.SECURE_BUSINESS_ORIGIN_EIN,
            nextPath: PAGES.SECURE_BUSINESS_ADDRESS,
            previousPath: PAGES.SECURE_BUSINESS_ORIGIN_NAME,
          },
          {
            path: PAGES.SECURE_BUSINESS_ADDRESS,
            nextPath: PAGES.SECURE_BUSINESS_REVIEW,
            previousPath: PAGES.SECURE_BUSINESS_ORIGIN_EIN,
          },
          {
            path: PAGES.SECURE_BUSINESS_REVIEW,
            nextPath: PAGES.BUSINESS_ACCOUNT.SECURE_NAME,
            previousPath: PAGES.SECURE_BUSINESS_ADDRESS,
          },
        ],
      },
      {
        title: i18.t('name'),
        path: PAGES.BUSINESS_ACCOUNT.SECURE_NAME,
        nextPath: PAGES.BUSINESS_ACCOUNT.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_BUSINESS_ADDRESS,
      },
      {
        title: i18.t('phoneNumber'),
        path: PAGES.BUSINESS_ACCOUNT.SECURE_PHONE_NUMBER,
        previousPath: PAGES.BUSINESS_ACCOUNT.SECURE_NAME,
        preSkipPath: PAGES.BUSINESS_ACCOUNT.SECURE_NAME,
        nextPath: PAGES.BUSINESS_ACCOUNT.SECURE_DOB,
      },
      {
        title: i18.t('dob'),
        path: PAGES.BUSINESS_ACCOUNT.SECURE_DOB,
        nextPath: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY,
        previousPath: PAGES.BUSINESS_ACCOUNT.SECURE_PHONE_NUMBER,
      },
      {
        title: i18.t('identityVerification'),
        path: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY,
        nextPath: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY_SSN,
        previousPath: PAGES.BUSINESS_ACCOUNT.SECURE_DOB,
        skipPath: PAGES.ADDRESS,
        items: [
          {
            path: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY_SSN,
            nextPath: PAGES.ADDRESS,
            previousPath: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY,
          },
        ],
      },
    ],
  },
  {
    title: i18.t('address'),
    path: PAGES.ADDRESS,
    nextPath: PAGES.ADDRESS_ENTER,
    previousPath: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY,
    preSkipPath: PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY,
    items: [
      {
        path: PAGES.ADDRESS_ENTER,
        nextPath: PAGES.ADDRESS_DONE,
        previousPath: PAGES.ADDRESS,
      },
      {
        path: PAGES.ADDRESS_DONE,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        previousPath: PAGES.ADDRESS_ENTER,
      },
    ],
  },
  {
    title: i18.t('fund'),
    path: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    nextPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
    previousPath: PAGES.ADDRESS_DONE,
    skipPath: PAGES.REVIEW,
    items: [
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.PLAID,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.WIRE,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CHECK,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CRYPTOCURRENCY,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.REVIEW,
      },
    ],
  },
  {
    title: i18.t('review'),
    path: PAGES.REVIEW,
    nextPath: PAGES.AGREEMENT,
    previousPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
    preSkipPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    items: [
      {
        path: PAGES.AGREEMENT,
        previousPath: PAGES.REVIEW,
        nextPath: '/',
      },
    ],
  },
];
